module.exports = __webpack_public_path__ + "static/media/boulevard_bzname.44637f29.png";